import apiClient from './apiClient';

export const getSeries = (companie, tip) =>
  apiClient.get('/smartbill/series/', { params: { companie, ...(tip ? { tip } : {}) } });

export const getTaxRates = (companie) =>
  apiClient.get('/smartbill/tax/', { params: { companie } });

export const getDocuments = (clientId, params = {}) =>
  apiClient.get(`/clienti/${clientId}/smartbill/`, { params });

export const createDocument = (clientId, payload) =>
  apiClient.post(`/clienti/${clientId}/smartbill/`, payload);

export const getDocument = (docId) =>
  apiClient.get(`/smartbill/${docId}/`);

export const patchDocument = (docId, payload) =>
  apiClient.patch(`/smartbill/${docId}/`, payload);

export const convertToFiscala = (docId, meta = {}) =>
  apiClient.post(`/smartbill/${docId}/`, { meta });

export const getExchangeRate = (currency) =>
  apiClient.get('/smartbill/exchange/', { params: { currency } });

export const downloadPdf = (docId) =>
  apiClient.get(`/smartbill/${docId}/pdf/`, { responseType: 'blob' });

export const getAllDocuments = (params = {}) =>
  apiClient.get('/smartbill/', { params });

export const getPayments = (docId) =>
  apiClient.get(`/smartbill/${docId}/incasari/`);

export const addPayment = (docId, payload) =>
  apiClient.post(`/smartbill/${docId}/incasari/`, payload);

export const stornoDocument = (docId) =>
  apiClient.post(`/smartbill/${docId}/storno/`);

export const sendFacturiEmail = (clientId, payload) =>
  apiClient.post(`/clienti/${clientId}/send-facturi/`, payload).then(r => r.data);
